import React, { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import { useObserver } from 'mobx-react-lite';
import { useStores } from '../../../store';
import { DownloadResume } from '../resume_output';

const Resume13 = () => {
  const { ResumeStore } = useStores();
  const resumeRef = useRef(null);

  const handleDownload = useReactToPrint({
    content: () => resumeRef.current,
  });

  return useObserver(() => (
    <>
      <DownloadResume onClick={handleDownload}/>
      <div className="flex w-full mx-auto bg-white shadow-lg border border-gray-300" ref={resumeRef}>
        <div className="bg-[#2d2d2d] text-white p-5 w-1/3 text-center">
          <div className="mb-6">
            <img
              className="rounded-full w-36 h-36 mx-auto object-cover mb-4"
              src={ResumeStore?.resumeBuilder?.profile || 'https://images.unsplash.com/photo-1508341591423-4347099e1f19?q=80&w=1000&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8bWVufGVufDB8fDB8fHww'}
              alt="Profile"
            />
            <h1 className="text-2xl mb-2">{ResumeStore?.resumeBuilder.personalDetails.firstName} {ResumeStore?.resumeBuilder.personalDetails.lastName}</h1>
          </div>
          <div className="mb-6">
            <h2 className="text-xl border-b border-white pb-2">Contact Info</h2>
            <p>{ResumeStore?.resumeBuilder.personalDetails.address}</p>
            <p>{ResumeStore?.resumeBuilder.personalDetails.phone}</p>
            <p>{ResumeStore?.resumeBuilder.personalDetails.email}</p>
          </div>
          <div className="mb-6">
            <h2 className="text-xl border-b border-white pb-2">About Me</h2>
            <p>{ResumeStore?.resumeBuilder.profileSummary}</p>
          </div>
          <div className="mb-6">
            <h2 className="text-xl border-b border-white pb-2">Personal Details</h2>
            <p>Date of birth: {ResumeStore?.resumeBuilder.personalDetails.dateOfBirth}</p>
            <p>Nationality: {ResumeStore?.resumeBuilder.personalDetails.nationality}</p>
            <p>Visa status: {ResumeStore?.resumeBuilder.personalDetails.visaStatus}</p>
            <p>Marital status: {ResumeStore?.resumeBuilder.personalDetails.maritalStatus}</p>
          </div>
          <div className="mb-6">
            <h2 className="text-xl border-b border-white pb-2">Languages</h2>
            {ResumeStore?.resumeBuilder.languages.map((language, index) => (
              <p key={index}>{language.language}</p>
            ))}
          </div>
          <div className="mb-6">
            <h2 className="text-xl border-b border-white pb-2">Hobbies</h2>
            <p>{ResumeStore?.resumeBuilder.hobbies?.join(', ')}</p>
          </div>
        </div>
        <div className="p-5 w-2/3">
          <div className="mb-6">
            <h2 className="text-xl border-b border-gray-800 pb-2">Work Experience</h2>
            {ResumeStore?.resumeBuilder.employementHistory.map((job, index) => (
              <div key={index} className="mb-4">
                <h3 className="text-lg font-semibold">{job.jobTitle}</h3>
                <p>{job.company} | {job.city} | {job.startDate} - {job.endDate}</p>
                <p>{job.description}</p>
              </div>
            ))}
          </div>
          <div className="mb-6">
            <h2 className="text-xl border-b border-gray-800 pb-2">Education</h2>
            {ResumeStore?.resumeBuilder.education.map((edu, index) => (
              <div key={index} className="mb-4">
                <h3 className="text-lg font-semibold">{edu.degree}</h3>
                <p>{edu.school} | {edu.city} | {edu.startDate} - {edu.endDate}</p>
                <p>{edu.description}</p>
              </div>
            ))}
          </div>
          <div className="mb-6">
            <h2 className="text-xl border-b border-gray-800 pb-2">Skills</h2>
            <div className="flex flex-wrap">
              {ResumeStore?.resumeBuilder.skills.map((skill, index) => (
                <p key={index} className="w-1/2">{skill}</p>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  ));
}

export default Resume13;
